<template>
	<div class="page container">
		<!--		<h1 class="page__title">-->
		<!--			My Learning-->
		<!--		</h1>-->
		<v2-welcome />
		<div class="separator" />
		<div class="page__nav-menu">
			<router-link
				class="page__nav-menu__link"
				activeClass="page__nav-menu__link-active"
				v-for="(link, key) in getLinks"
				:key="key"
				:to="link.route"
			>
				{{ link.text }}
			</router-link>
		</div>
		<div class="content">

			<div class="main deal-packs">
				<p class="deal-packs__subtitle">
					You have <span class="bold">{{ progressDealPacks.length }} deal packs in progress</span>
				</p>

				<div class="deal-packs__list" v-if="progressDealPacks.length">
					<v2-deal-pack-card v-for="dealPack in progressDealPacks" :key="dealPack.id" :deal-pack="dealPack" />
				</div>

				<div class="deal-packs__list-empty border-box" v-else>
					<div class="deal-packs__list-empty--text">
						Start to improve your game with <br /> Bridge128 deal packs
					</div>
					<router-link class="deal-packs__list-empty--link button" to="/deal-store">
						Discover deal packs
					</router-link>
				</div>

				<p class="deal-packs__subtitle">
					You have <span class="bold">completed {{ completedDealPacks.length }} deal packs</span>
				</p>

				<template v-if="completedDealPacks.length">
					<div class="deal-packs__list-small">
						<v2-deal-pack-card-small v-for="dealPack in completedDealPacks" :key="dealPack.id" :deal-pack="dealPack" />
					</div>
				</template>

			</div>

			<div class="separator mini" />
		</div>
	</div>
</template>

<route>
	{
		"meta": {
			"showTopPicks": true
		}
	}
</route>

<script>
	import api      from '@/services/api';
	import V2Welcome  from '@/components/v2/myLearnings/V2Welcome';
	import V2DealPackCard from '@/components/dealPacks/V2DealPackCard';
	import V2DealPackCardSmall from '@/components/dealPacks/V2DealPackCardSmall.vue';

	export default {
		metaInfo: {
			title: 'My Deals'
		},

		layout: 'v2default',

		components: {
			V2DealPackCardSmall,
			V2DealPackCard,
			V2Welcome
		},

		data: () => ({
			dealPacks: [],
			pagination: {
				perPage: 21,
				currentPage: 1,
				totalPages: 0
			},
			totalItems:  0
		}),
		computed: {
			getBreadcrumbs () {
				return [
					// TODO: Let's hide the breadcrumbs since we already have the same links below
					// {
					// 	path: '/my-deals',
					// 	text: 'My Deals'
					// }
				].filter(Boolean);
			},

			getLinks () {
				return [
					{
						text: 'My Courses',
						route: '/my-courses'
					},
					{
						text: 'My Deals',
						route: '/my-deals'
					}
				];
			},

			progressDealPacks () {
				return this.dealPacks.filter((item) => {
					return item.activityProgress !== 100;
				});
			},

			completedDealPacks () {
				return this.dealPacks.filter((item) => {
					return item.activityProgress === 100;
				});
			}
		},
		created () {
			this.setDealPacks();
		},
		methods: {
			onPaginate (value) {
				this.pagination.currentPage = value;
				this.setDealPacks();
			},

			async setDealPacks () {
				const response = await api.dealPacks.getCurrentUsersDealPacks({
					include: 'metadata',
					searchString: '',
					page: -1,
					per: this.pagination.perPage
				});
				if (!response) {
					this.$store.commit('ui/showError');
					return false;
				}

				this.totalItems = response.meta.totalItems;
				this.pagination.totalPages = response.meta.numPages;
				this.pagination.currentPage = response.meta.page;
				this.dealPacks = response.results;
				this.$store.commit('ui/setBreadcrumbs', {
					breadcrumbs: this.getBreadcrumbs
				});
				this.$store.commit('ui/setLoadingIsHidden');
			}
		}
	};

</script>

<style lang="scss" scoped>

.page {

	&__title {
		@include font(24px, $c-darkest-navy, 500, 31px);
		margin-bottom: 16px;
	}

	&__nav-menu {
		display: flex;
		gap: 12px;
		align-items: center;
		margin-bottom: 20px;
		@include font();

		&__link {
			padding: 5px 5px;
			box-sizing: border-box;
			font-size: 20px;
			line-height: 24px;
			color: $c-dark-navy;
			border-radius: 8px;
			transition: background 0.2s ease;

			&:hover {
				background: $c-white-d2;
			}

			&-active {
				border-bottom: 2px solid $c-dark-navy !important;
				border-radius: 8px 8px 0px 0px !important;
			}

		}
	}
}

.content {

  .deal-packs {
    width: 100%;

    &__subtitle {
      @include font(18px, $c-darkest-navy, 400, 23px);
      margin-bottom: 16px;

      .bold {
        font-weight: 700;
      }
    }

    &__list {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      gap: 12px;
      margin-bottom: 36px;

      .deal-pack-card {
        width: 100%;
      }
    }

    &__list-small {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-bottom: 12px;
    }

    .border-box {
      border-radius: 4px;
      border: 1px dashed $c-gray-d;
    }

    &__more {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 94px;
      padding: 20px;

      &--text {
        width: 180px;
        @include font(18px, $c-medium-navy, 400, 23px);

        &.mini {
          display: none
        }
      }

    }

    &__list-empty {
      display: flex;
      flex-direction: column;
      gap: 24px;
      height: 335px;
      max-width: 440px;
      width: 100%;
      padding: 12px;
      align-items: center;
      justify-content: center;
      margin-bottom: 36px;

      &--text {
        @include font(18px, $c-medium-navy, 400, 23px);
        text-align: center;
      }

    }
  }

  @media (max-width: 1279px) {
    flex-direction: column;

    .side {
      width: 100%;
    }

    .deal-packs {
      width: 100%;

      &__title {
        font-size: 20px;
        line-height: 26px;
      }

      &__list {
        grid-template-columns: 1fr;
      }

      &__more {
        flex-direction: column;
        gap: 12px;
        height: 123px;
        padding: 26.5px 20px;

        &--text {
          display: none;

          &.mini {
            display: flex;
            font-size: 16px;
            line-height: 20px;
            width: 100%;
            justify-content: center;
          }
        }

        &--link {
          height: 37px;
          padding: 8px 20px;
          font-size: 16px;
          line-height: 20px;
        }

      }

      &__list-empty {
        height: 200px;
      }
    }
  }

  @media (min-width: 768px) and (max-width: 1279px) {
    .deal-packs {

      &__list {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }
  }
}

</style>
